<style media="screen" type="text/css">
.btn-box {
  width: 35px;
  background-color: transparent;
  display: inline-block;
}
</style>
<template>
  <v-app-bar class="border-b elevation-1" color="white" height="70" outlined>
    <v-row class="pl-0 pr-3">
      <v-col class="py-5 pl-0" cols="5" md="6">
        <div class="btn-box">
          <v-btn v-if="show_back_btn" fab small style="margin-top:-4px" text @click="goBack">
            <img alt="img" class="v-align-middle" src="../../../assets/back.svg">
          </v-btn>
        </div>
        <!-- page title -->
        <span class="page-title ml-1">{{ pageTitle($route.name) }}</span><br><br>
      </v-col>
      <v-col class="text-right py-5" cols="7" md="6">

        <!--  display  the btn for the warehouse admin -->
        <span v-if="$store.state.user_type!=$keys.WHOLESALER">
					<v-btn class="mr-2 br-8" color="primary" depressed @click="dispatchOrder">
						<b>{{ $lang.DISPATCH_ORDER }}</b>
					</v-btn>
					<v-btn class="mr-2 br-8" color="primary" depressed @click="$router.push({name:'accept-shipment'})">
						<b>{{ $lang.ACCEPT_ORDER }}</b>
					</v-btn>
					
					<v-btn class="br-8 border-w-2" color="primary" outlined
                 @click="$router.push({name:'drop-shipment'})">
					<b>{{ $lang.DROP }}</b>
				</v-btn>
			</span>
        <v-badge
            v-if="$store.state.user_type==$keys.WHOLESALER&&$store.state.new_notification_count>0"
            bordered
            color="primary"
            dot
            overlap
        >
          <v-btn class="ml-2 " color="primary" depressed fab small
                 text
                 @click="$router.push({name:'notification-list'})">
            <img alt="" src="@/assets/navbar/notification.svg" width="26px">
          </v-btn>
        </v-badge>

        <v-btn v-else class="ml-2 "
               color="primary" depressed fab small text
               @click="$router.push({name:'notification-list'})">
          <img alt="" src="@/assets/navbar/notification.svg" width="26px">
        </v-btn>

        <v-btn class="ml-2" color="primary" depressed fab small @click="$router.push({name:'new-shipment'})">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn class="ml-2 small-screen small-screen-flex " depressed fab small @click="openDrawer">
          <v-icon>mdi-menu</v-icon>
        </v-btn>

      </v-col>
    </v-row>

  </v-app-bar>
</template>
<script>
const allowed_subdrawer = ["manage-retailers", "add-retailer", "edit-retailer", "retailer-details", "manage-wholesaler", "add-a-wholesaler", "edit-wholesaler", "wholesaler-details", "manage-team", "add-an-agent", "edit-agent", "employee-details", "manage-subscription-plans", "add-a-subscription-plan", "edit-subscription-plan", "employee-payout-history", "manage-warehouses", "create-warehouse", "edit-warehouse", "manage-line", "add-line", "edit-line", "line-details", "subscription-history", "retailer-offer-image", "wholesaler-offer-image", "create-warehouse", "edit-warehouse", 'user-subscription', 'user-subscriptions', 'add-new-subscription', 'payout-details']

import {mapGetters} from 'vuex';

export default {
  data() {
    return {
      show_back_btn: false,
    }
  },
  watch: {
    $route(to, from) {
      this.toggleBackBtn();
      // this.setActiveTab(to);
      if (allowed_subdrawer.includes(to.name))
        this.openNav()
      else
        this.closeNav();
    }
  },
  computed: mapGetters({
    getDrawerItems: 'drawer/getDrawerItems'
  }),
  mounted() {
    this.toggleBackBtn()
    if (allowed_subdrawer.includes(this.$route.name))
      this.openNav()
    else
      this.closeNav();
  },
  methods: {
    toggleBackBtn() {
      let allowed_routes = ['bulk-shipment', 'wholesaler-profile-details', 'wholesaler-edit-profile', 'wholesaler-details', 'add-a-wholesaler', 'edit-wholesaler', 'shipment-details', 'raise-an-issue', 'support-ticket-details', 'returns', 'collections', 'faq', 'new-product', "withdrawal-details", 'add-an-agent', 'edit-agent', "employee-details", "add-retailer", "retailer-details", "edit-retailer", 'dispatch-history', 'dispatch-details', 'collection-details', 'collection-history', "withdrawal--details", "subscription-history", "add-a-subscription-plan", "edit-subscription-plan", "add-line", "line-details", "edit-line", 'add-new-subscription', 'payout-details'];
      if (!allowed_routes.includes(this.$route.name)) {
        this.show_back_btn = false
      } else
        this.show_back_btn = true
    },
    pageTitle(text) {
      text = text.replace(/-/g, ' ');
      // text=text.replace(/wholesaler/g, '');
      text = text.toUpperCase()
      return text
    },
    setActiveTab(to) {
      this.getDrawerItems
    },
    goBack() {


      console.log(this.$route)
      console.log(this.$router)
      this.$router.go(-1)
    },
    dispatchOrder() {
      this.$store.dispatch('setPageLoader', true)
      this.$router.push({name: 'dispatch-shipment'})
    },
    openNav() {
      console.log("here")
      setTimeout(() => {
        document.getElementById("mySidenav").style.width = "156px";
        document.getElementById("main").style.marginLeft = "156px";
      }, 500);
    },
    closeNav() {
      setTimeout(() => {
        document.getElementById("mySidenav").style.width = "0";
        document.getElementById("main").style.marginLeft = "0";
      }, 500);
    },
    openDrawer() {
      console.log("open")
      this.$store.dispatch('drawer/setPrimaryDrawer', true)

    }

  }
}
</script>
